import { NavigationShell } from "./navigation-shell"
import type { NavigationShellProps } from "./navigation-types"

const megaItems = [
	{
		label: "Platform",
		href: "#features",
		dropdownColumns: [
			{ title: "Build", items: [{ label: "Designer mode", href: "#features", description: "Generate complete pages from premium section families." }, { label: "Code mode", href: "#proof", description: "Edit the App Router project with the same component registry." }] },
			{ title: "Grow", items: [{ label: "CMS surfaces", href: "#cms", description: "Blogs, cases, testimonials, FAQs, products, and locations." }, { label: "Schema hooks", href: "#schema", description: "JSON-LD builders for crawlable generated sites." }] },
		],
		featuredCard: { eyebrow: "New", title: "Core Component Library", description: "Server-first sections with leaf client islands and strong metadata defaults.", href: "#features" },
	},
	{ label: "Proof", href: "#proof" },
	{ label: "Pricing", href: "#pricing" },
	{ label: "Contact", href: "#contact" },
]

export type NavbarMegaMenuProps = NavigationShellProps

export function NavbarMegaMenu(props: NavbarMegaMenuProps) {
	return <NavigationShell {...props} items={props.items ?? megaItems} />
}